import React from 'react';
import { Link } from 'react-router-dom';
import { ICON_CART, ICON_LINK, ICON_SHIELD } from '../../utils/icons';
import styled from 'styled-components';
import { products } from '../../utils/data';


const OtherProducts = () => {
    return (
        <>
            <StyledProducts id='products'>
                <div className="container pry-text">
                    <div className="mb-5 text-center">
                        <h3 className="">
                            Checkout other products from Reni
                        </h3>
                    </div>

                    <div className="row">
                        {products?.map(({ img, title, content, url }, i) =>
                            <div className="col-md-6 mb-3" key={i}>
                                <div className="card h-100">
                                    <div className="card-body my-4 py-5 d-flex gap-3">
                                        <div className="">
                                            <img src={img} alt={title} width='70px'
                                                className='' />
                                        </div>
                                        <div className="">
                                            <div className="d-flex justify-content-between mb-3">
                                                <h6 className="mb-3 fw-bold">
                                                    {title}
                                                </h6>
                                                <a href={url} target='_blank'>
                                                    <small>
                                                        {ICON_LINK} visit site
                                                    </small>
                                                </a>
                                            </div>
                                            <p className="text-justify">
                                                {content}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        )}
                    </div>
                </div>
            </StyledProducts>

        </>
    );
};

export default OtherProducts;

const StyledProducts = styled.section`


small {
    color: var(--yellow-color);
    border:1px var(--yellow-color) solid;
    border-radius: 20px;
    padding: .1rem .8rem !important;
    font-size: 15px;
}
`;
